export function getSelectedAdvertiser() {
  const selectedAdvertiserStorage = localStorage.getItem('selectedAdvertiser');

  return JSON.parse(selectedAdvertiserStorage);
}

export function setSelectedAdvertiser(newSelectedAdvertiser) {
  localStorage.setItem('selectedAdvertiser', JSON.stringify(newSelectedAdvertiser));
}
